import PropTypes from "prop-types";
import ChatUserAvatar from "../sharedComponents/ChatUserAvatar/ChatUserAvatar";
import VipStar from "../sharedComponents/VipStar/VipStar";
import "./chatMentions.scss";

const ChatMentionDropdown = ({
  users = [],
  activeIndex = 0,
  onSelect,
}) => {
  if (!users.length) return null;

  return (
    <ul className="chat-mention-dropdown" role="listbox">
      {users.map((user, index) => (
        <li key={user._id}>
          <button
            type="button"
            className={`chat-mention-option${
              index === activeIndex ? " is-active" : ""
            }${user.isVip ? " is-vip" : ""}`}
            onMouseDown={(e) => {
              e.preventDefault();
              onSelect?.(user);
            }}
          >
            <ChatUserAvatar user={user} size="xs" />
            <span className="chat-mention-option__name">
              {user.isVip && <VipStar />}
              {user.userName}
            </span>
          </button>
        </li>
      ))}
    </ul>
  );
};

ChatMentionDropdown.propTypes = {
  users: PropTypes.arrayOf(PropTypes.object),
  activeIndex: PropTypes.number,
  onSelect: PropTypes.func,
};

export default ChatMentionDropdown;
